import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderPatientsByPatientIdCoverages: build.query<
      GetV2ProviderPatientsByPatientIdCoveragesApiResponse,
      GetV2ProviderPatientsByPatientIdCoveragesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/coverages`,
      }),
    }),
    postV2ProviderPatientsByPatientIdCoverages: build.mutation<
      PostV2ProviderPatientsByPatientIdCoveragesApiResponse,
      PostV2ProviderPatientsByPatientIdCoveragesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/coverages`,
        method: "POST",
        body: queryArg.createCoverageRequest,
      }),
    }),
    deleteV2ProviderPatientsByPatientIdCoveragesAndCoverageId: build.mutation<
      DeleteV2ProviderPatientsByPatientIdCoveragesAndCoverageIdApiResponse,
      DeleteV2ProviderPatientsByPatientIdCoveragesAndCoverageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/coverages/${queryArg.coverageId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderPatientsByPatientIdCoveragesAndCoverageId: build.query<
      GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdApiResponse,
      GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/coverages/${queryArg.coverageId}`,
      }),
    }),
    putV2ProviderPatientsByPatientIdCoveragesAndCoverageId: build.mutation<
      PutV2ProviderPatientsByPatientIdCoveragesAndCoverageIdApiResponse,
      PutV2ProviderPatientsByPatientIdCoveragesAndCoverageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/coverages/${queryArg.coverageId}`,
        method: "PUT",
        body: queryArg.updateCoverageRequest,
      }),
    }),
    postV2ProviderPatientsByPatientIdInsuranceCard: build.mutation<
      PostV2ProviderPatientsByPatientIdInsuranceCardApiResponse,
      PostV2ProviderPatientsByPatientIdInsuranceCardApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/insurance-card`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderPatientsByPatientIdCoveragesApiResponse =
  /** status 200 OK */ CoveragesListResponse;
export type GetV2ProviderPatientsByPatientIdCoveragesApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdCoveragesApiResponse =
  /** status 201 Created */ CoverageResponse2;
export type PostV2ProviderPatientsByPatientIdCoveragesApiArg = {
  patientId: string;
  createCoverageRequest: CreateCoverageRequest;
};
export type DeleteV2ProviderPatientsByPatientIdCoveragesAndCoverageIdApiResponse =
  /** status 200 OK */ SuccessResponse;
export type DeleteV2ProviderPatientsByPatientIdCoveragesAndCoverageIdApiArg = {
  patientId: string;
  coverageId: string;
};
export type GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdApiResponse =
  /** status 200 OK */ CoverageResponse2;
export type GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdApiArg = {
  patientId: string;
  coverageId: string;
};
export type PutV2ProviderPatientsByPatientIdCoveragesAndCoverageIdApiResponse =
  /** status 200 OK */ CoverageResponse2;
export type PutV2ProviderPatientsByPatientIdCoveragesAndCoverageIdApiArg = {
  patientId: string;
  coverageId: string;
  updateCoverageRequest: UpdateCoverageRequest;
};
export type PostV2ProviderPatientsByPatientIdInsuranceCardApiResponse =
  /** status 200 OK */ InsuranceCardExtractionResponseSchema;
export type PostV2ProviderPatientsByPatientIdInsuranceCardApiArg = {
  patientId: string;
};
export type PatientAddress = {
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (apartment, suite, etc.) */
  line2?: string | null;
  /** Optional landline/location phone in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code (5 or 9 digit format, e.g., 12345 or 12345-6789) */
  zip?: string | null;
};
export type CoverageResponse = {
  consent_document_url?: string | null;
  consent_on_file: boolean;
  coverage_order: number;
  created_at?: string | null;
  effective_date?: string | null;
  group_number?: string | null;
  kind: string;
  member_id?: string | null;
  /** List of field names that are required but missing (e.g., ['member_id']). UI should highlight these fields. */
  missing_fields?: string[] | null;
  organization_id: string;
  patient_id: string;
  patient_insurance_coverage_id: string;
  payer_id?: string | null;
  payer_name?: string | null;
  payer_uuid?: string | null;
  plan_name?: string | null;
  relationship_to_subscriber: string;
  status: string;
  subscriber_address?: PatientAddress | null;
  subscriber_dob?: string | null;
  subscriber_first_name?: string | null;
  subscriber_last_name?: string | null;
  subscriber_sex?: string | null;
  termination_date?: string | null;
  updated_at?: string | null;
};
export type CoveragesListResponse = {
  coverages: CoverageResponse[];
  total: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type PatientAddress2 = {
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (apartment, suite, etc.) */
  line2?: string | null;
  /** Optional landline/location phone in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code (5 or 9 digit format, e.g., 12345 or 12345-6789) */
  zip?: string | null;
};
export type CoverageResponse2 = {
  consent_document_url?: string | null;
  consent_on_file: boolean;
  coverage_order: number;
  created_at?: string | null;
  effective_date?: string | null;
  group_number?: string | null;
  kind: string;
  member_id?: string | null;
  /** List of field names that are required but missing (e.g., ['member_id']). UI should highlight these fields. */
  missing_fields?: string[] | null;
  organization_id: string;
  patient_id: string;
  patient_insurance_coverage_id: string;
  payer_id?: string | null;
  payer_name?: string | null;
  payer_uuid?: string | null;
  plan_name?: string | null;
  relationship_to_subscriber: string;
  status: string;
  subscriber_address?: PatientAddress2 | null;
  subscriber_dob?: string | null;
  subscriber_first_name?: string | null;
  subscriber_last_name?: string | null;
  subscriber_sex?: string | null;
  termination_date?: string | null;
  updated_at?: string | null;
};
export type PatientAddress3 = {
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (apartment, suite, etc.) */
  line2?: string | null;
  /** Optional landline/location phone in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code (5 or 9 digit format, e.g., 12345 or 12345-6789) */
  zip?: string | null;
};
export type CreateCoverageRequest = {
  /** S3 URL of consent document */
  consent_document_url?: string | null;
  /** Authorization signature on file */
  consent_on_file?: boolean;
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Coverage start date */
  effective_date?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** Coverage kind: insurance, self-pay, other */
  kind?: string;
  /** Member/policy ID on insurance card (required for active coverages) */
  member_id?: string | null;
  /** External payer identifier */
  payer_id?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  /** Plan name */
  plan_name?: string | null;
  /** Relationship to subscriber: self, spouse, child, other */
  relationship_to_subscriber?: string;
  /** Coverage status */
  status?: string;
  /** Subscriber address (only if relationship != 'self') */
  subscriber_address?: PatientAddress3 | null;
  /** Subscriber DOB (only if relationship != 'self') */
  subscriber_dob?: string | null;
  /** Subscriber first name (only if relationship != 'self') */
  subscriber_first_name?: string | null;
  /** Subscriber last name (only if relationship != 'self') */
  subscriber_last_name?: string | null;
  /** Subscriber sex: Male/Female/Unknown (only if relationship != 'self') */
  subscriber_sex?: string | null;
  /** Coverage end date */
  termination_date?: string | null;
};
export type SuccessResponse = {
  /** Whether the operation succeeded */
  success?: boolean;
};
export type PatientAddress4 = {
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (apartment, suite, etc.) */
  line2?: string | null;
  /** Optional landline/location phone in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code (5 or 9 digit format, e.g., 12345 or 12345-6789) */
  zip?: string | null;
};
export type UpdateCoverageRequest = {
  consent_document_url?: string | null;
  consent_on_file?: boolean | null;
  coverage_order?: number | null;
  effective_date?: string | null;
  group_number?: string | null;
  kind?: string | null;
  member_id?: string | null;
  payer_id?: string | null;
  payer_name?: string | null;
  plan_name?: string | null;
  relationship_to_subscriber?: string | null;
  status?: string | null;
  subscriber_address?: PatientAddress4 | null;
  subscriber_dob?: string | null;
  subscriber_first_name?: string | null;
  subscriber_last_name?: string | null;
  subscriber_sex?: string | null;
  termination_date?: string | null;
};
export type InsuranceCardExtractionResponseSchema = {
  card_image_url_back?: string | null;
  card_image_url_front?: string | null;
  confidence?: number;
  effective_date?: string | null;
  group_number?: string | null;
  member_id?: string | null;
  payer_name?: string | null;
  plan_name?: string | null;
  subscriber_first_name?: string | null;
  subscriber_last_name?: string | null;
  subscriber_relationship?: string | null;
};
